import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import BASE_URL from "./BASE_URL.js"
const service = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  timeout: 1200000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.url.indexOf('http') == -1) {
      config.url = BASE_URL.ZSM_BASE_API + config.url
    }
    showFullScreenLoading()
    // if (store.state['zsm-user'].token) {
    //   config.headers['token'] = getToken('zsm-token')
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response
    tryHideFullScreenLoading()
    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 200) {
      // Message({
      //   message: res.message || 'error',
      //   type: 'error',
      //   duration: 3000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('您已经退出，您可以取消停留在这个页面，或再次登录', '确认登出', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
        })
      }

      if (res.code === 502) {
        return Promise.reject(new Error(res.message || '服务器升级,请稍后再试'))
      }

      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      return res.data
      Message({
        message: '请求错误',
        type: 'error',
        duration: 3 * 1000
      })
    }
  },
  error => {
    tryHideFullScreenLoading()
    // ('err' + error) // for debug
    /*Message({
      message: '请求失败,请检查网络',
      type: 'error',
      duration: 3 * 1000
    })*/
    return Promise.reject(error)
  }
)

import { Loading } from 'element-ui'
let loading
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '数据加载中',
    customClass: 'loading',
    background: 'rgba(250, 250, 250, 0)'
  })
}

function endLoading() {
  loading.close()
}
let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

export default service
